import {
	Button,
	Dialog,
	DialogBody,
	DialogContent,
	DialogOpenChangeData,
	DialogOpenChangeEvent,
	DialogSurface,
	DialogTitle,
	DialogTrigger
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { Dispatch, SetStateAction } from 'react';
import NewStory from './Form/NewStory';

interface AddStoryDialogProps {
	showModal: boolean;
	setShowModal: Dispatch<SetStateAction<boolean>>;
}

export default function AddStoryDialog(props: AddStoryDialogProps) {
	return (
		<Dialog
			open={props.showModal}
			onOpenChange={(
				_event: DialogOpenChangeEvent,
				data: DialogOpenChangeData
			) => {
				props.setShowModal(data.open);
			}}
		>
			<DialogSurface>
				<DialogBody>
					<DialogTitle
						action={
							<DialogTrigger action='close'>
								<Button
									appearance='subtle'
									aria-label='close'
									icon={<Dismiss24Regular />}
								/>
							</DialogTrigger>
						}
					>
						New Story
					</DialogTitle>
					<DialogContent>
						<NewStory toggleDialog={props.setShowModal} />
					</DialogContent>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
}
